import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationSV from './locales/sv/translation.json';
import translationDA from './locales/da/translation.json';
import translationNO from './locales/no/translation.json';
import translationFI from './locales/fi/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  sv: {
    translation: translationSV
  },
  da: {
    translation: translationDA
  },
  no: {
    translation: translationNO
  },
  fi: {
    translation: translationFI
  }
};

// Initialize i18next
i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    supportedLngs: ['sv', 'en', 'da', 'no', 'fi'],
    fallbackLng: 'en',
    debug: process.env.NODE_ENV !== 'production',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true,
    },
    detection: {
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      order: ['querystring', 'navigator', 'htmlTag', 'path', 'localStorage', 'cookie', 'sessionStorage']
    }
  });

export default i18n;